import { ICommonResponse } from '../core/api/http-methods/common-response.type';
import type { IGetRewardBrandsResponse, RewardsResponse, UIReward } from '../types/rewards';
import { api } from './calls';
import { apiClient } from './client';
import { withScheduleVerdicts } from '../utils/rewardSchedule';
import { queryFunction } from './utils';

/**
 *
 *
 * @param queryData
 * @returns
 */
export const getUserRewards = async <T extends 'active' | 'past'>(
  queryData?:
    | {
        query: {
          status: T;
        };
      }
    | undefined
) =>
  await api.get<RewardsResponse<T> | null>(
    `/users/me/rewards${queryFunction(queryData?.query)}`
  );

export const getBrands = async () => {
  return (
    await apiClient.get<ICommonResponse<IGetRewardBrandsResponse>>(
      `/rewards/brands`
    )
  ).data;
};

export const getRewards = async (
  entity_id: string,
  status: 'all' | 'active' | 'past' = 'all'
) => {
  if (entity_id === 'aye') {
    entity_id = localStorage.getItem('ayeAdminEntityId') || '';
  }
  const res = (
    await apiClient.get<ICommonResponse<{ rewards: UIReward[]; entity_name: string }>>(
      `/rewards/?status=${status}&entity_id=${entity_id}`
    )
  ).data;

  // Judge each reward's day-and-hour window HERE, once, as the response lands —
  // never per render. See `withScheduleVerdicts` for why that distinction is
  // the customer's and not a matter of taste.
  if (res?.success && res.data?.rewards) {
    res.data.rewards = withScheduleVerdicts(res.data.rewards);
  }
  return res;
};

export const getAvailablePoints = async (entity_id: string) => {
  if (entity_id === 'aye') {
    entity_id = localStorage.getItem('ayeAdminEntityId') || '';
  }
  return (
    await apiClient.get<
      ICommonResponse<{ points: number; membership_merchant_alias?: string }>
    >(`/rewards/points?entity_id=${entity_id}`)
  ).data;
};
